import { Oauth2Client } from "@/services/oauth2-client";
import { Button } from "@mantine/core";

export function ClientPage() {
    async function handleAuth(){
        Oauth2Client.auth()
    }
    return (
        <>
            <Button onClick={handleAuth}>Test auth</Button>
        </>
    )
}